import { EntityService } from '@/services/EntityService';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class AboServicesService extends EntityService {
  static get entity() {
    return 'abo-services';
  }

  static async getStatuses() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/statuses`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
